const axios = require('axios');
import { captureException } from '@/src/lib/monitoring';

const fetch = (url: any, method: any, param1: any, param2: any) => {
  return new Promise((resolve, reject) => {
    method(url, param1, param2)
      .then((res: any) => resolve(res.data))
      .catch((err: any) => {
        captureException(err, {
          tags: { source: 'api-error', endpoint: url, statusCode: err?.response?.status ?? 0 },
          extra: { responseData: err?.response?.data },
        });

        const defaultError = {
          code: 500,
          status: 'error',
          message: 'Failed to fetch data. Please contact Bas.',
        };

        if (!err.response) {
          reject(defaultError);
        } else if (!err.response.data) {
          reject(defaultError);
        } else {
          reject(err.response.data);
        }
      });
  });
};

export const fetchIpAddress = async () =>
  fetch(`https://ipapi.co/json`, axios.get, '', {
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const fetchSendUserTracker = async (payload: any, token: any) =>
  // fetch(`${process.env.MS_USER_TRACKER}/track`, axios.post, '', {
  fetch(`${process.env.MS_USER_TRACKER}/track`, axios.post, payload, {
    headers: {
      'Content-Type': 'application-bribrain/json',
      // Authorization: token,
      Authorization: 'f0zc4ZmPDvh5jI1lEJkv30jPHq5iGLKA8OghZEa50fQG7',
      accept: 'application-bribrain/json',
    },
  });